export const API_ROOT = process.env.VUE_APP_API_ROOT;
